// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { polygonZkEvm as _polygonZkEvm } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the polygonZkEvm chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1101
 * Chain Name: Polygon zkEVM
 * Default Block Explorer: https://zkevm.polygonscan.com
 * Default RPC URL: https://zkevm-rpc.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { polygonZkEvm } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: polygonZkEvm,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const polygonZkEvm = createCommon({
	..._polygonZkEvm,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
